
            const data = {"name":"glyph/24/chevron-down","data":{"width":"24","height":"24","viewBox":"0 0 18 18","data":"<path pid=\"0\" d=\"M9 13.5a.744.744 0 0 1-.53-.22L2.22 7.03a.75.75 0 1 1 1.061-1.061l5.72 5.72 5.72-5.72a.75.75 0 1 1 1.061 1.061l-6.25 6.25a.748.748 0 0 1-.53.22Z\" _fill=\"#212121\" class=\"nc-icon-wrapper\"/>","originalColors":[{"type":"fill","color":"#212121"}],"stopColors":[]}}
        
                    module.exports = data
                    